export const PAYMENT_METHOD_POPULATE_FULL = ["pm_owner"];
export const PAYMENT_METHOD_POPULATE_DEFAULT = [];
export const PAYMENT_METHOD_POPULATE_LIST = [];
export const PAYMENT_METHOD_POPULATE = {
    FULL: PAYMENT_METHOD_POPULATE_FULL,
    DEFAULT: PAYMENT_METHOD_POPULATE_DEFAULT,
    LIST: PAYMENT_METHOD_POPULATE_LIST,
};
